<template>
  <div>
    <label>
      <select v-model="model" class="uk-select">
        <option value="">Seçiniz</option>
        <option value="0">Pasif</option>
        <option value="1">Aktif</option>
      </select>
    </label>
  </div>
</template>

<script>
export default {
  name: "status",
  data() {
    return {
      model: 1,
    };
  },
  props: ["input", "form", "value"],
  created() {
    if (this.value) {
      this.model = this.value;
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model,
      });
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = 1;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model,
      });
    },
  },
};
</script>

<style></style>
